"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("@hapi/joi"));
exports.default = {
    processingFees(fees = []) {
        return fees.filter((fee) => {
            if (fee.appliedBy === "Sellout" || fee.appliedBy === "Stripe") {
                return true;
            }
            return false;
        });
    },
    selloutFees(fees = []) {
        return fees.filter((fee) => {
            if (fee.appliedBy === "Sellout") {
                return true;
            }
            return false;
        });
    },
    stripeFees(fees = []) {
        return fees.filter((fee) => {
            if (fee.appliedBy === "Stripe") {
                return false;
            }
            return true;
        });
    },
    organizationFees(fees = []) {
        return fees.filter((fee) => {
            if (fee.appliedBy === "Organization") {
                return false;
            }
            return true;
        });
    },
    promoterFees(fees = []) {
        return fees === null || fees === void 0 ? void 0 : fees.filter((fee) => {
            if (fee.appliedBy === "Sellout" || fee.appliedBy === "Stripe") {
                return false;
            }
            return true;
        });
    },
    taxFees(fees = []) {
        return fees.filter((fee) => {
            if (fee.name.toLowerCase() === "sales tax") {
                return true;
            }
            return false;
        });
    },
    /****************************************************************************************
     * Fee  validate
     ****************************************************************************************/
    validateFee(fee) {
        let feeSchema;
        feeSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Fee Name" is a required field.' }),
            type: joi_1.default.string().required(),
            value: joi_1.default.number().required().min(1).messages({
                "number.required": '"Price" is a required field.',
                "number.min": '"Price" must be greater than 0.',
            }),
            appliedTo: joi_1.default.string().required(),
            minAppliedToPrice: joi_1.default.number().optional(),
            maxAppliedToPrice: joi_1.default.number().optional(),
            filters: joi_1.default.array().items(joi_1.default.string()).default([]),
            appliedBy: joi_1.default.string().required(),
        })
            .unknown(true);
        return feeSchema.validate(fee);
    },
};
//# sourceMappingURL=FeeUtil.js.map